import { render, staticRenderFns } from "./EditServiceCategoryDialog.vue?vue&type=template&id=3efbe0e2&"
import script from "./EditServiceCategoryDialog.vue?vue&type=script&lang=ts&"
export * from "./EditServiceCategoryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
